import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { Box, IconButton, Stack } from "@mui/material";
import { Attachment, ImageOutlined } from "@mui/icons-material";
import clsx from "clsx";
import { AppConstant, LangConstant } from "const";
import { HandleUploadingInput } from "components";
import { UPLOAD_FILE_TYPE, useUploadFileContext } from "../context/UploadFileContext";

const ACCEPTABLE_MEDIA_TYPES = [...AppConstant.SUPPORT_VIDEO_TYPES, AppConstant.ACCEPTABLE_IMAGE_TYPES].join(", ");
const SendMessageFile = () => {
  const classes = useStyles();
  const { t: getLabel } = useTranslation();
  const { uploadFiles, setFileType } = useUploadFileContext();

  const handleChangeUploadType = fileType => () => setFileType(fileType);

  const handleFileChange = fileList => uploadFiles(fileList);

  return (
    <Stack direction="row" spacing={0.5}>
      <Box onClick={handleChangeUploadType(UPLOAD_FILE_TYPE.file)}>
        <HandleUploadingInput
          accept="*"
          className="hidden"
          id="icon-button-document"
          type="file"
          multiple
          onChange={handleFileChange}
        />
        <label htmlFor="icon-button-document" title={getLabel(LangConstant.TXT_POPUP_DOCUMENT)}>
          <IconButton className={clsx(classes.rotateIcon)} component="span" edge="end">
            <Attachment variant="contained" color="action" />
          </IconButton>
        </label>
      </Box>

      <Box onClick={handleChangeUploadType(UPLOAD_FILE_TYPE.media)}>
        <HandleUploadingInput
          accept={ACCEPTABLE_MEDIA_TYPES}
          className="hidden"
          id="icon-button-gallery"
          type="file"
          multiple
          onChange={handleFileChange}
        />
        <label htmlFor="icon-button-gallery" title={getLabel(LangConstant.TXT_POPUP_GALLERY)}>
          <IconButton component="span" edge="end">
            <ImageOutlined variant="contained" color="action" />
          </IconButton>
        </label>
      </Box>
    </Stack>
  );
};

export default memo(SendMessageFile);

const useStyles = makeStyles({
  rotateIcon: {
    transform: "rotate(-45deg)",
  },
});
